import { Component } from 'preact'
import cx from 'classnames'

import { TextNode } from '../textNodes'

class NewPaybarFooterSubscriptionMessage extends Component {
  get subscriptionStatus() {
    if (this.props.isCancelled) return I18n.t('newPaybar.cancelled')

    return I18n.t(`newPaybar.success.${this.props.product}.${this.props.type}`)
  }

  get autoRenewCaption() {
    return I18n.t('newPaybar.success.autoRenews')
  }

  get text() {
    if (this.props.mentionAutoRenew && !this.props.isCancelled) {
      return [
        this.subscriptionStatus,
        `<span class="newPaybarFooter-messageAutoRenew">${this.autoRenewCaption}</span>`,
      ].join('<br/>')
    }

    return this.subscriptionStatus
  }

  render() {
    const classNames = cx('newPaybarFooter-message', {
      is__cancelled: this.props.isCancelled,
      is__compact: this.props.isCompact,
    })

    return (<TextNode className={ classNames } html={ this.text } />)
  }
}

export default NewPaybarFooterSubscriptionMessage
